<template>
  <div class="home">
    <van-nav-bar title="兽药剂型" v-if="isWx==1" left-arrow @click-left="onClickLeft" fixed/>
    <van-nav-bar title="兽药剂型" v-else fixed/>
    <div class="navheight"></div>
    <!-- <van-search v-model="value" show-action placeholder="请输入关键字进行搜索" @search="onSearch">
      <template #action>
        <div v-if="value.length>0" @click="onCancel">清空</div>
      </template>
    </van-search> -->
    <van-collapse v-model="activeNames">
      <van-collapse-item title="1、概述"  name="1">
        <div class="content">
          <p>兽药制剂是把原粉制成适合疾病治疗需要和优化药动药效的药物剂型，通常同种药物可以制备成多种剂型。虽同种药物的药理作用相同，但因其剂型不同，所以给药途径会有所差异，进而可能产生不同的疗效。</p>
        </div>
      </van-collapse-item>
      <van-collapse-item title="2、兽药剂型-固体制剂" name="2">
        <div class="content">
          <h3>片剂：</h3>
          <p>将一种或多种药物与适量赋形剂混合后压制成的片状制剂，主要供内服，如红霉素片、盐酸林可霉素片等。</p>
          <h3>粉剂/散剂：</h3>
          <p>将一种或多种药物粉碎后均匀混合而制成的干燥粉末状剂型，一般可掺入饲料或溶于水中给药，也可局部外用。如：氟苯尼考粉、清瘟败毒散。可用作添加剂添加于饲料中，作为防治用药。优点是方便贮藏且品质相对稳定；缺点是可能混合不均，且动物采集量的不确定性会影响给药剂量。</p>
          <h3>预混剂：</h3>
          <p>药物与适宜的基质均匀混合制成的粉末状或颗粒状制剂，如，氟苯尼考预混剂。因为药物已经与饲料混合均匀，作为防治用药。优点是药物混合饲料均匀稳定；缺点是动物采集量的不确定性会影响给药剂量。</p>
          <h3>可溶性粉：</h3>
          <p>可溶性粉剂是由一种或几种药物与助溶剂、助悬剂等辅料组成的可溶性粉末。投入饮水中使药物溶解，均匀分散，供动物饮用。如氟苯尼考可溶性粉。水溶性较好，在患病猪采食少但饮水不受影响的情况下，可保证药物摄入量。但是气温的变化影响猪的饮水量，药物剂量不易掌握，因此要保证足够的饮水量和饮水时间。同时应注意药物容易受潮结快。</p>
          <h3>粉针：</h3>
          <p>用喷雾干燥法或冷冻干燥法制成的注射级无菌粉末，通常使用无菌注射用水或者氯化钠注射液等溶解后，静脉或者肌内注射使用，例如：注射用青霉素钠。</p>
        </div>
      </van-collapse-item>
      <van-collapse-item title="3、兽药剂型-半固体制剂" name="3">
        <div class="content">
          <h3>软膏剂、乳膏剂、糊剂：</h3>
          <p>软膏剂以凡士林（黄石脂）为基础，混入定量的药物，制成半固体型制剂，如各种抗生素或磺胺类软膏，供局部外用治疗。如：硫酸新霉素软膏。</p>
          <h3>混悬剂：</h3>
          <p>一般是难溶性的固体药物，分散在液体介质中而成。一般采用注射或者口服给药。注意注射用混悬液不得用于静脉注射或椎管注射。如：碘醚柳胺混悬液。</p>
        </div>
      </van-collapse-item>
      <van-collapse-item title="4、兽药剂型-气体制剂" name="4">
        <div class="content">
          <p>气体剂型以气体为分散介质，现常用气雾剂。可供吸入给药或皮肤黏膜给药。</p>
        </div>
      </van-collapse-item>
      <van-collapse-item title="5、兽药剂型特点与选用" name="5">
        <div class="content">
          <p>不同剂型药物对应不同的给药途径，而对应药物的吸收顺序不同，同一种药物制成不同的剂型所对应的药物的吸收顺序也不同，一般吸收顺序由快到慢为：静脉输液>气雾给药>肌肉注射>皮下注射>直肠或舌下给药>可溶性粉或口服液饮水给药>拌料内服或固体药剂>皮肤给药。</p>
          <p>同时，由于每种药物的稳定性不同，其对应的制剂不同，因而药效也会不同。例如氟苯尼考、阿莫西林等难溶性或溶解性差的固体药物来说，就会加工成很细小的粉末提高溶解速度进而提高药物的生物利用度。例如青霉素青霉素 G会与胃酸反应失效，因此一般是注射粉针。例如把硫酸镁制成药水，热敷可以消肿，口服可以导泻，而制成针剂却成了抗惊厥药，用于治疗尿毒症、破伤风与高血压性脑病等。</p>
          <p>同时还要注意不同的兽药剂型对于猪只毒副作用，贮存时间和条件，以及不同厂家生产的同一兽药的有效含量的差别，所以兽医临床中，要根据防治疾病的目的、药物本身及其有效成分的性质等，选择合适的药物剂型。</p>
        </div>
      </van-collapse-item>
    </van-collapse>
    <Top :btnFlag="btnFlag"/>
  </div>
</template>

<script>
import { searchHighlight } from '@/utils/utils.js'
import Top from '@/components/top.vue'
// import { shopCombination } from '@/api/resetApi.js'

export default {
  name: 'pigfarm',
  components: { Top },
  data() {
    return {
      btnFlag:false,
      value:'',
      activeNames: ['1'],
      isWx:1,
    };
  },
  created(){
    const ua = window.navigator.userAgent.toLowerCase();
    if(ua.indexOf('micromessenger') == -1) {
      this.isWx = 1
    }else{
      this.isWx = 2
    }
  },
  methods: {
    onClickLeft() {
      this.$router.back(-1)
    },
    onSearch() {
      this.activeNames = ['1','2','3','4','5']
      let val = this.value
      setTimeout(function (){
        searchHighlight(val)
      }, 100);
    },
    onCancel() {
      this.value = ''
    }
  },
}
</script>

<style lang="scss">
  .van-nav-bar .van-icon{
        color: #181818;
    }
  @import '../../assets/style/knowledge.scss';
</style>
